import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import React from "react";
import PropTypes from "prop-types";
import { useSafeTranslatedUrls, useTranslator } from "@jutro/locale";
import { tooltipBaseProps } from "@jutro/prop-types";
var propTypes = _objectSpread(_objectSpread({}, tooltipBaseProps), {}, {
  id: PropTypes.string,
  className: PropTypes.string,
  titleClass: PropTypes.string,
  textClass: PropTypes.string,
  linkClass: PropTypes.string
});
export var TooltipContent = function (_ref) {
  var id = _ref.id,
    text = _ref.text,
    title = _ref.title,
    link = _ref.link,
    href = _ref.href,
    className = _ref.className,
    titleClass = _ref.titleClass,
    textClass = _ref.textClass,
    linkClass = _ref.linkClass,
    safeHref = useSafeTranslatedUrls()(href),
    translator = useTranslator();
  return React.createElement("div", {
    id: id,
    className: className,
    role: "alert"
  }, title && React.createElement("div", {
    className: titleClass
  }, React.createElement("strong", null, translator(title))), text && React.createElement("div", {
    className: textClass
  }, translator(text)), link && safeHref && React.createElement("a", {
    className: linkClass,
    href: safeHref,
    target: "_blank",
    rel: "noopener noreferrer"
  }, translator(link)));
};
TooltipContent.propTypes = propTypes, TooltipContent.displayName = "TooltipContent", TooltipContent.__docgenInfo = {
  description: "Content component that renders inside tooltip",
  methods: [],
  displayName: "TooltipContent",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Id for the tooltip content"
    },
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the component"
    },
    titleClass: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the title"
    },
    textClass: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the text"
    },
    linkClass: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the link"
    }
  },
  composes: ["@jutro/prop-types"]
}, TooltipContent.__docgenInfo = {
  componentName: "TooltipContent",
  packageName: "@jutro/components",
  description: "Content component that renders inside tooltip",
  displayName: "TooltipContent",
  methods: [],
  actualName: "TooltipContent",
  props: {
    id: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Id for the tooltip content"
    },
    className: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the component"
    },
    titleClass: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the title"
    },
    textClass: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the text"
    },
    linkClass: {
      type: {
        name: "string"
      },
      required: !1,
      description: "Class to customize the link"
    }
  },
  composes: ["@jutro/prop-types"]
};